/**
 * Illustrative first-cycle REKOVELLE starting dose from AMH (pmol/L) + body weight (kg).
 * Mirrors the labelled algorithm structure: AMH < 15 pmol/L → fixed 12 µg;
 * AMH ≥ 15 pmol/L → µg/kg rate decreasing with AMH; maximum 12 µg/day.
 * Must be verified against the approved local SmPC before any external use.
 */
const RATE_BANDS: { maxAmh: number; rate: number }[] = [
  { maxAmh: 16, rate: 0.19 },
  { maxAmh: 17, rate: 0.18 },
  { maxAmh: 18, rate: 0.17 },
  { maxAmh: 20, rate: 0.16 },
  { maxAmh: 22, rate: 0.15 },
  { maxAmh: 24, rate: 0.14 },
  { maxAmh: 27, rate: 0.13 },
  { maxAmh: 32, rate: 0.12 },
  { maxAmh: 39, rate: 0.11 },
]

export const MAX_DAILY_DOSE = 12

export function rekovelleStartingDose(amh: number, weight: number): number {
  const a = Math.round(amh)
  if (a < 15) return MAX_DAILY_DOSE
  const band = RATE_BANDS.find((b) => a <= b.maxAmh)
  const rate = band ? band.rate : 0.1
  return Math.min(MAX_DAILY_DOSE, Math.round(rate * weight * 10) / 10)
}

export function formatMicrograms(dose: number): string {
  return `${dose.toFixed(dose % 1 === 0 ? 0 : 1)} µg`
}
